export const permissionsKeys = {
  page: 'content-management.dynamic-page',
  pageBlockFind: 'content-management.dynamic-page.find',
  pageBlockPreview: 'content-management.dynamic-page.preview',
  pageBlockCreate: 'content-management.dynamic-page.create',
  pageBlockUpdate: 'content-management.dynamic-page.update',
  pageBlockRemove: 'content-management.dynamic-page.remove',
  pageBlockUpdatePublish: 'content-management.publish.dynamic-page.update',
  pageBlockUpdateStatusToDraft: 'content-management.dynamic-page.updateStatusToDraft',
  pageBlockUpdateInactivate: 'content-management.inactivate.dynamic-page.update',
};
